<template>
  <section class="creation-guide-bar pc-only">
    <h2 class="creation-guide-bar__title">
      <span>Generate AI video with </span>
      <Resource
        :src="getFeUrl('/youyan-platform/character-intro/character-detail/title-avatar-3x.png')"
        alt="avatar"
        class="creation-guide-bar__title-img"
      />
      <span>this {{ is2DHuman ? '2D' : '3D' }} avatar</span>
    </h2>
    <p class="creation-guide-bar__desc">
      Bring your ideas to life with a natural voice,
      <Resource
        :src="
          getFeUrl('/youyan-platform/character-intro/character-detail/title-avatar-group-3x.png')
        "
        alt="natural-group"
      />smooth movements, and vivid expressions.
    </p>
    <ArrowBtn
      @click.stop="emits('create-work')"
      class="creation-guide-bar__btn"
      text="Get Started for Free"
    />
  </section>
</template>

<script setup lang="ts">
import { getFeUrl } from '@/utils/url';
import ArrowBtn from '../arrow-btn.vue';

defineProps<{
  is2DHuman?: boolean;
}>();

const emits = defineEmits(['create-work']);
</script>

<style lang="scss" scoped>
.creation-guide-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: clamp(50px, 4.17vw, 80px);
  padding-bottom: clamp(50px, 4.17vw, 80px);
  min-width: 1200px;
}
.creation-guide-bar__title {
  display: flex;
  justify-content: center;
  gap: clamp(0.8rem, 0.83vw, 1rem);
  align-items: flex-end;
  color: var(--x-text-1);
  text-align: center;
  font-size: clamp(36px, 2.5vw, 48px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: clamp(24px, 1.67vw, 32px);
  img {
    width: clamp(94px, 6.51vw, 125px);
    height: clamp(95px, 6.56vw, 126px);
    margin-bottom: clamp(7px, 0.47vw, 9px);
  }
}
.creation-guide-bar__desc {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(0.8rem, 0.83vw, 1rem);
  color: var(--x-text-5);
  font-size: clamp(24px, 1.67vw, 32px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
  img {
    width: clamp(77px, 5.34vw, 102.5px);
    height: clamp(30px, 2.08vw, 40px);
  }
}
.creation-guide-bar__btn {
  margin-top: clamp(30px, 2.08vw, 40px);
}
</style>
